<template>
  <div
    v-if="cptdOfferCardComp"
    class="RequestedOfferCardTemplateMethodContainer"
  >
    <component
      :is="cptdOfferCardComp"
      v-if="cptdOfferCardComp"
      :offer="offer"
      v-bind="$attrs"
    />
  </div>
</template>
<script>
import { partnerHasFullIntegration } from '@/helpers/offers'
import OfferCard from '@/components/commomComponents/cards/OfferCard.vue'
import AutoRequestedOfferCardContainer from '@/containers/loans/auto/offer/AutoRequestedOfferCardContainer.vue'
import NoCollateralRequestedOfferCardContainer from '@/containers/loans/no-collateral/offer/NoCollateralRequestedOfferCardContainer.vue'
import AutoNonFullPartnerRequestedOfferCardContainer from '@/containers/loans/auto/offer/AutoNonFullPartnerRequestedOfferCardContainer.vue'
import NoCollateralNonFullPartnerRequestedOfferCardContainer from '@/containers/loans/no-collateral/offer/NoCollateralNonFullPartnerRequestedOfferCardContainer.vue'
import HomeEquityNonFullPartnerRequestedOfferCardContainer from '@/containers/loans/home-equity/offer/HomeEquityNonFullPartnerRequestedOfferCardContainer.vue'
import FatalErrorOfferCardContainer from '@/containers/loans/FatalErrorOfferCardContainer.vue'
export default {
  name: 'RequestedOfferCardTemplateMethodContainer',
  components: {
    OfferCard,
    AutoRequestedOfferCardContainer,
    NoCollateralRequestedOfferCardContainer,
    AutoNonFullPartnerRequestedOfferCardContainer,
    NoCollateralNonFullPartnerRequestedOfferCardContainer,
    HomeEquityNonFullPartnerRequestedOfferCardContainer,
    FatalErrorOfferCardContainer,
  },
  props: {
    offer: { type: Object, required: true },
  },
  computed: {
    cptdOfferCardComp() {
      const { partner, status, product_type } = this.offer
      if (partner && status === 'FATAL_ERROR') {
        return 'FatalErrorOfferCardContainer'
      }

      if (
        partner &&
        product_type &&
        partnerHasFullIntegration({
          partner,
          product_type,
        })
      ) {
        switch (product_type) {
          case 'auto':
            return 'AutoRequestedOfferCardContainer'
          case 'no-collateral':
            return 'NoCollateralRequestedOfferCardContainer'
          default:
            return null
        }
      } else {
        switch (product_type) {
          case 'auto':
            return 'AutoNonFullPartnerRequestedOfferCardContainer'
          case 'no-collateral':
            return 'NoCollateralNonFullPartnerRequestedOfferCardContainer'
          case 'home-equity':
            return 'HomeEquityNonFullPartnerRequestedOfferCardContainer'
          default:
            return null
        }
      }
    },
  },
}
</script>
<style lang="scss">
.RequestedOfferCardTemplateMethodContainer {
  & > .partner-card {
    margin-top: 0;
    margin-bottom: 0;
    max-width: 100%;

    &:first-child {
      margin: 0;
    }
  }
}
</style>
